/* tslint:disable */
/* eslint-disable */
/**
 * Munchi Dashboard Server Api
 * The Munchi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BaseKioskDto } from '../models';
// @ts-ignore
import type { BaseStationDto } from '../models';
// @ts-ignore
import type { ConnectKioskDto } from '../models';
// @ts-ignore
import type { ConnectStationDto } from '../models';
// @ts-ignore
import type { PaymentTerminalResponseDto } from '../models';
/**
 * PaymentTerminalApi - axios parameter creator
 * @export
 */
export const PaymentTerminalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Connect a kiosk to a payment terminal
         * @param {ConnectKioskDto} connectKioskDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connect: async (connectKioskDto: ConnectKioskDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectKioskDto' is not null or undefined
            assertParamExists('connect', 'connectKioskDto', connectKioskDto)
            const localVarPath = `/api/v1/payment-terminal/connect-kiosk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectKioskDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Connect a station to a payment terminal
         * @param {ConnectStationDto} connectStationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectStation: async (connectStationDto: ConnectStationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectStationDto' is not null or undefined
            assertParamExists('connectStation', 'connectStationDto', connectStationDto)
            const localVarPath = `/api/v1/payment-terminal/connect-station`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectStationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disconnect a kiosk from a payment terminal
         * @param {BaseKioskDto} baseKioskDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnect: async (baseKioskDto: BaseKioskDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseKioskDto' is not null or undefined
            assertParamExists('disconnect', 'baseKioskDto', baseKioskDto)
            const localVarPath = `/api/v1/payment-terminal/disconnect-kiosk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseKioskDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disconnect a station from a payment terminal
         * @param {BaseStationDto} baseStationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectStation: async (baseStationDto: BaseStationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseStationDto' is not null or undefined
            assertParamExists('disconnectStation', 'baseStationDto', baseStationDto)
            const localVarPath = `/api/v1/payment-terminal/disconnect-station`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseStationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find all payment terminals by business ID
         * @param {string} businessId The ID of the business to fetch payment terminals for
         * @param {GetAllTerminalsByBusinessIdChannelEnum} channel The channel filter
         * @param {Array<GetAllTerminalsByBusinessIdProviderEnum>} provider The payment provider filter. Accepts a single value (?provider&#x3D;viva) or multiple (?provider&#x3D;viva&amp;provider&#x3D;stripe)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTerminalsByBusinessId: async (businessId: string, channel: GetAllTerminalsByBusinessIdChannelEnum, provider: Array<GetAllTerminalsByBusinessIdProviderEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('getAllTerminalsByBusinessId', 'businessId', businessId)
            // verify required parameter 'channel' is not null or undefined
            assertParamExists('getAllTerminalsByBusinessId', 'channel', channel)
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('getAllTerminalsByBusinessId', 'provider', provider)
            const localVarPath = `/api/v1/payment-terminal/{businessId}`
                .replace(`{${"businessId"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentTerminalApi - functional programming interface
 * @export
 */
export const PaymentTerminalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentTerminalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Connect a kiosk to a payment terminal
         * @param {ConnectKioskDto} connectKioskDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connect(connectKioskDto: ConnectKioskDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentTerminalResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connect(connectKioskDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentTerminalApi.connect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Connect a station to a payment terminal
         * @param {ConnectStationDto} connectStationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectStation(connectStationDto: ConnectStationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentTerminalResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectStation(connectStationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentTerminalApi.connectStation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Disconnect a kiosk from a payment terminal
         * @param {BaseKioskDto} baseKioskDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnect(baseKioskDto: BaseKioskDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentTerminalResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnect(baseKioskDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentTerminalApi.disconnect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Disconnect a station from a payment terminal
         * @param {BaseStationDto} baseStationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectStation(baseStationDto: BaseStationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentTerminalResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectStation(baseStationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentTerminalApi.disconnectStation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Find all payment terminals by business ID
         * @param {string} businessId The ID of the business to fetch payment terminals for
         * @param {GetAllTerminalsByBusinessIdChannelEnum} channel The channel filter
         * @param {Array<GetAllTerminalsByBusinessIdProviderEnum>} provider The payment provider filter. Accepts a single value (?provider&#x3D;viva) or multiple (?provider&#x3D;viva&amp;provider&#x3D;stripe)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTerminalsByBusinessId(businessId: string, channel: GetAllTerminalsByBusinessIdChannelEnum, provider: Array<GetAllTerminalsByBusinessIdProviderEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentTerminalResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTerminalsByBusinessId(businessId, channel, provider, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentTerminalApi.getAllTerminalsByBusinessId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentTerminalApi - factory interface
 * @export
 */
export const PaymentTerminalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentTerminalApiFp(configuration)
    return {
        /**
         * 
         * @summary Connect a kiosk to a payment terminal
         * @param {ConnectKioskDto} connectKioskDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connect(connectKioskDto: ConnectKioskDto, options?: RawAxiosRequestConfig): AxiosPromise<PaymentTerminalResponseDto> {
            return localVarFp.connect(connectKioskDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Connect a station to a payment terminal
         * @param {ConnectStationDto} connectStationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectStation(connectStationDto: ConnectStationDto, options?: RawAxiosRequestConfig): AxiosPromise<PaymentTerminalResponseDto> {
            return localVarFp.connectStation(connectStationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disconnect a kiosk from a payment terminal
         * @param {BaseKioskDto} baseKioskDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnect(baseKioskDto: BaseKioskDto, options?: RawAxiosRequestConfig): AxiosPromise<PaymentTerminalResponseDto> {
            return localVarFp.disconnect(baseKioskDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disconnect a station from a payment terminal
         * @param {BaseStationDto} baseStationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectStation(baseStationDto: BaseStationDto, options?: RawAxiosRequestConfig): AxiosPromise<PaymentTerminalResponseDto> {
            return localVarFp.disconnectStation(baseStationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find all payment terminals by business ID
         * @param {string} businessId The ID of the business to fetch payment terminals for
         * @param {GetAllTerminalsByBusinessIdChannelEnum} channel The channel filter
         * @param {Array<GetAllTerminalsByBusinessIdProviderEnum>} provider The payment provider filter. Accepts a single value (?provider&#x3D;viva) or multiple (?provider&#x3D;viva&amp;provider&#x3D;stripe)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTerminalsByBusinessId(businessId: string, channel: GetAllTerminalsByBusinessIdChannelEnum, provider: Array<GetAllTerminalsByBusinessIdProviderEnum>, options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentTerminalResponseDto>> {
            return localVarFp.getAllTerminalsByBusinessId(businessId, channel, provider, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentTerminalApi - object-oriented interface
 * @export
 * @class PaymentTerminalApi
 * @extends {BaseAPI}
 */
export class PaymentTerminalApi extends BaseAPI {
    /**
     * 
     * @summary Connect a kiosk to a payment terminal
     * @param {ConnectKioskDto} connectKioskDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTerminalApi
     */
    public connect(connectKioskDto: ConnectKioskDto, options?: RawAxiosRequestConfig) {
        return PaymentTerminalApiFp(this.configuration).connect(connectKioskDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Connect a station to a payment terminal
     * @param {ConnectStationDto} connectStationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTerminalApi
     */
    public connectStation(connectStationDto: ConnectStationDto, options?: RawAxiosRequestConfig) {
        return PaymentTerminalApiFp(this.configuration).connectStation(connectStationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disconnect a kiosk from a payment terminal
     * @param {BaseKioskDto} baseKioskDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTerminalApi
     */
    public disconnect(baseKioskDto: BaseKioskDto, options?: RawAxiosRequestConfig) {
        return PaymentTerminalApiFp(this.configuration).disconnect(baseKioskDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disconnect a station from a payment terminal
     * @param {BaseStationDto} baseStationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTerminalApi
     */
    public disconnectStation(baseStationDto: BaseStationDto, options?: RawAxiosRequestConfig) {
        return PaymentTerminalApiFp(this.configuration).disconnectStation(baseStationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find all payment terminals by business ID
     * @param {string} businessId The ID of the business to fetch payment terminals for
     * @param {GetAllTerminalsByBusinessIdChannelEnum} channel The channel filter
     * @param {Array<GetAllTerminalsByBusinessIdProviderEnum>} provider The payment provider filter. Accepts a single value (?provider&#x3D;viva) or multiple (?provider&#x3D;viva&amp;provider&#x3D;stripe)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTerminalApi
     */
    public getAllTerminalsByBusinessId(businessId: string, channel: GetAllTerminalsByBusinessIdChannelEnum, provider: Array<GetAllTerminalsByBusinessIdProviderEnum>, options?: RawAxiosRequestConfig) {
        return PaymentTerminalApiFp(this.configuration).getAllTerminalsByBusinessId(businessId, channel, provider, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllTerminalsByBusinessIdChannelEnum = {
    Wolt: 'Wolt',
    MunchiOnline: 'MunchiOnline',
    MunchiKiosk: 'MunchiKiosk',
    MunchiPos: 'MunchiPos',
    UberEats: 'UberEats',
    Foodora: 'Foodora',
    Bolt: 'Bolt',
    MunchiKioskV2: 'MunchiKioskV2',
    Kiosk: 'Kiosk',
    WoltStorefront: 'WoltStorefront',
    Storefront: 'Storefront',
    MunchiPay: 'MunchiPay'
} as const;
export type GetAllTerminalsByBusinessIdChannelEnum = typeof GetAllTerminalsByBusinessIdChannelEnum[keyof typeof GetAllTerminalsByBusinessIdChannelEnum];
/**
 * @export
 */
export const GetAllTerminalsByBusinessIdProviderEnum = {
    stripe: 'stripe',
    viva: 'viva',
    nets: 'nets',
    worldline: 'worldline'
} as const;
export type GetAllTerminalsByBusinessIdProviderEnum = typeof GetAllTerminalsByBusinessIdProviderEnum[keyof typeof GetAllTerminalsByBusinessIdProviderEnum];
